import { render } from "./CreateSubCommunityView.vue?vue&type=template&id=4695b069"
import script from "./CreateSubCommunityView.vue?vue&type=script&lang=js"
export * from "./CreateSubCommunityView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__